export default [
  'tania@foodforjoe.es',
  'daniel.garrido@foodforjoe.es',
  'david.fernandez@foodforjoe.es',
  'albane@foodforjoe.es',
  'dana@foodforjoe.es',
  'data@foodforjoe.com',
  'adriana.molvinger@foodforjoe.es',
  'miriam@foodforjoe.es',
  'diego@foodforjoe.es',
  'josep@foodforjoe.es',
  'nuria@foodforjoe.es',
  'jonathan@foodforjoe.com',
  'daniel@wedo-solutions.com',
  'office@wedo-solutions.com',
];
